function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
  fill: "#070A0D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.4816 13.3524C5.18277 13.1696 5 12.8441 5 12.4945V10.5428C5 10.4681 5.02001 10.3961 5.05736 10.332C5.17343 10.1319 5.4309 10.0639 5.63101 10.1813L10.0361 12.7493C10.2936 12.9001 10.4523 13.1749 10.4523 13.4737V15.4962C10.4523 15.5882 10.4269 15.6803 10.3789 15.759C10.2335 15.9964 9.924 16.0712 9.68653 15.9257L5.4816 13.3524ZM12.0478 9.64631C12.3053 9.79707 12.464 10.0719 12.464 10.3707V14.4743C12.464 14.5957 12.3987 14.7077 12.2933 14.7664L11.3288 15.3094C11.3168 15.3161 11.3034 15.3214 11.2901 15.3254V13.0468C11.2901 12.752 11.1353 12.4785 10.8819 12.3264L7.01309 10.0119V7.4398C7.01309 7.36509 7.03311 7.29305 7.07046 7.22902C7.18652 7.02891 7.444 6.96087 7.6441 7.07827L12.0478 9.64631ZM13.9756 6.61535C14.2344 6.76476 14.3931 7.04225 14.3931 7.34108V13.335C14.3931 13.4577 14.3251 13.5711 14.217 13.6298L13.3032 14.1234V9.95049C13.3032 9.65569 13.1484 9.38351 12.8963 9.23142L8.94214 6.85948V4.41949C8.94214 4.34478 8.96215 4.27274 8.99817 4.20871C9.11424 4.0086 9.37171 3.94056 9.57182 4.05663L13.9756 6.61535Z",
  fill: "#00D395"
});

var SvgComp = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgComp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/comp.68fa5f82.svg";
export { ForwardRef as ReactComponent };